import { useEffect, useState } from "react";
import { useAppDispatch } from "../../app/hook";
import { useParams, useNavigate, Link } from "react-router-dom";
import { showModal } from "../UI/modal/modal-slice";
import {
  formatDateHyphen,
  formatYearDate,
  formatDate,
} from "../../utils/format";
import {
  Box,
  Button,
  Form,
  FormField,
  Input,
  ColumnLayout,
  Container,
  SpaceBetween,
  Select,
  Header,
  Textarea,
  Tiles,
  DatePicker,
  TextContent,
  Badge,
} from "@cloudscape-design/components-themed";
import { LABELS, getGwCompanyList, CONTRACT_STYLES } from "./constants";
import {
  COMMON_LABELS,
  DivisionDict,
  addBlank,
  getDivisionItems,
  getFirstDivisionDict,
  getDivisionDict,
} from "../default-constants";
import {
  isNull,
  isLengthValid,
  isHalfNumberDecimalValid2 as isHalfNumberDecimalValid,
} from "../../utils/inputValidation";
import { getMessage } from "../../features/error/messages";
import {
  Division,
  IndividualCounselingProjectContentsItem,
  IndividualCounselingProjectContentsRegister,
  IndividualCounselingProjectContentsUpdate,
  IndividualCounselingProjectContentsdata,
  ComprehensiveCompanySearchResponse,
  ComprehensiveCompanySearchRequest,
} from "../../features/api-interfaces";
import {
  useGetDivisionQuery,
  usePostIndividualCounselingProjectContentsRegisterMutation,
  useGetGwCompaniesQuery,
  usePutIndividualCounselingProjectContentsUpdateMutation,
  useGetComprehensiveCompaniesQuery,
  useGetIndividualCounselingProjectContentsQuery,
} from "../../features/api";
import { getComprehensiveMerchantCodeItems } from "../../utils/common";

/* 
個別相談案件相談内容登録画面
 */
export const IndividualCounselingProjectContentsForm = (props: any) => {
  const navigator = useNavigate();
  const dispatch = useAppDispatch();
  const { individualConsultationNo, individualConsultationBranchNo } =
    useParams();
  const [code, setCode] = useState("-1");

  useEffect(() => {
    if (individualConsultationNo !== undefined) {
      setCode(individualConsultationNo);
    }
  }, [individualConsultationNo]);
  // const code = individualConsultationNo as string;

  // 登録画面か更新画面かのフラグ
  const isRegister = !individualConsultationBranchNo;

  //戻るボタンの表示確認フラグ（入力フォームに何か入力された場合はtrue）
  const [isFormEntered, setIsFormEntered] = useState(false);

  // 加盟店名
  const [merchantName, setMerchantName] = useState("");
  // サービス名
  const [contractServiceCode, setContractServiceCode] = useState({ value: "" });
  // サービス名一覧
  const [serviceNameList, setServiceNameList] = useState<DivisionDict[]>();
  //契約ルート
  const [contractRoute, setContractRoute] = useState<DivisionDict>({
    label: "　　　　",
    value: "",
  });
  //選択済み契約ルート
  const [selectedContractRoute, setSelectedContractRoute] =
    useState<DivisionDict>({
      label: "",
      value: "",
    });

  // 包括加盟店一覧
  const [comprehensiveMerchantList, setComprehensiveMerchantList] =
    useState<DivisionDict[]>();
  // 直接店舗一覧
  const [gwCompanyList, setGwCompanyList] = useState<DivisionDict[]>();
  //契約形態
  const [contractStyle, setContractStyle] = useState("");
  //相談者情報
  const [consulteeName, setConsulteeName] = useState("");
  //受付日
  const [receptionDate, setReceptionDate] = useState("");
  //相談理由
  const [consulationReason, setConsulationReason] = useState("");
  //検討状況
  const [considerationStatus, setConsiderationStatus] = useState({
    value: "",
    label: "",
  });
  //検討状況一覧
  const [considerationStatusList, setConsiderationStatusList] =
    useState<DivisionDict[]>();
  //検討方針
  const [considerationPolicy, setConsiderationPolicy] = useState("");
  //検討方針詳細
  const [considerationPolicyDetail, setConsiderationPolicyDetail] =
    useState("");
  //クレカ料率
  const [negotiatedCreditCardRate, setNegotiatedCreditCardRate] = useState("");
  //相談結果
  const [consulationResult, setConsulationResult] = useState("");
  //検討メモ
  const [consulationMemo, setConsulationMemo] = useState("");
  //事業者名
  const [companyName, setCompanyName] = useState("");
  //加盟店名
  const [merchantsName1, setMerchantsName1] = useState("");
  //契約内容
  const [contractDetails, setContractDetails] = useState("");
  //申し送り事項
  const [message, setMessage] = useState("");
  //ラジオ選択時の契約ルート
  const [, setContractRouteItem] = useState<DivisionDict[]>();
  //最終更新日
  const [updatedAt, setUpdatedAt] = useState("");
  //最終更新者
  const [updatedBy, setUpdatedBy] = useState("");
  //登録API
  const [registerIndividualCounselingProjectContents] =
    usePostIndividualCounselingProjectContentsRegisterMutation();
  //更新API
  const [updateIndividualCounselingProjectContents] =
    usePutIndividualCounselingProjectContentsUpdateMutation();

  //エラーメッセージ関連
  //加盟店名
  const [merchantNameErrorMsg, setMerchantNameErrorMsg] = useState("");
  // サービス名
  const [contractServiceCodeErrorMsg, setContractServiceCodeErrorMsg] =
    useState("");
  //契約形態
  const [contractStyleErrorMsg, setContractStyleErrorMsg] = useState("");
  //相談者情報
  const [consulteeNameErrorMsg, setConsulteeNameErrorMsg] = useState("");
  //受付日
  const [receptionDateErrorMsg, setReceptionDateErrorMsg] = useState("");
  //相談理由
  const [consulationReasonErrorMsg, setConsulationReasonErrorMsg] =
    useState("");
  //検討状況
  const [considerationStatusErrorMsg, setConsiderationStatusErrorMsg] =
    useState("");

  //検討方針
  const [considerationPolicyErrorMsg, setConsiderationPolicyErrorMsg] =
    useState("");
  //検討方針詳細
  const [
    considerationPolicyDetailErrorMsg,
    setConsiderationPolicyDetailErrorMsg,
  ] = useState("");
  //クレカ料率
  const [
    negotiatedCreditCardRateErrorMsg,
    setNegotiatedCreditCardRateErrorMsg,
  ] = useState("");
  //相談結果
  const [consulationResultErrorMsg, setConsulationResultErrorMsg] =
    useState("");
  //検討メモ
  const [consulationMemoErrorMsg, setConsulationMemoErrorMsg] = useState("");
  //申し送り事項
  const [messageErrorMsg, setMessageErrorMsg] = useState("");

  // 共通データを取得
  // 区分取得API呼び出し(親区分コード：3:契約サービス区分コード)
  const divisionData1 = useGetDivisionQuery("3");
  const contractServiceDivisions = divisionData1?.data as Division[];
  const contractServiceKbnItems: DivisionDict[] = addBlank(
    getDivisionItems(contractServiceDivisions)
  );
  useEffect(() => {
    setServiceNameList(contractServiceKbnItems);
  }, [divisionData1, contractServiceKbnItems]);

  // 取得API呼び出し(親区分コード：9:検討状況区分コード)
  const divisionData2 = useGetDivisionQuery("9");
  const considerationStatusDivisions = divisionData2?.data as Division[];
  const considerationStatusKbnItems: DivisionDict[] = addBlank(
    getDivisionItems(considerationStatusDivisions)
  );
  useEffect(() => {
    setConsiderationStatusList(considerationStatusKbnItems);
  }, [divisionData2, considerationStatusKbnItems]);

  const [, setGatewayFormKbn] = useState<DivisionDict>({
    label: "",
    value: "",
  });

  // 包括加盟店データを取得
  const comprehensiveCompanySearchRequest = {
    companyCode: "",
    invisibleComprehensiveCompanyNoList: [],
  } as ComprehensiveCompanySearchRequest;

  const comprehensiveMerchantListData = useGetComprehensiveCompaniesQuery(
    comprehensiveCompanySearchRequest
  );
  const comprehensiveMerchantListItem =
    comprehensiveMerchantListData?.data as ComprehensiveCompanySearchResponse[];
  const comprehensiveMerchantListItems: DivisionDict[] = addBlank(
    getComprehensiveMerchantCodeItems(comprehensiveMerchantListItem)
  );

  useEffect(() => {
    setComprehensiveMerchantList(comprehensiveMerchantListItems);
  }, [comprehensiveMerchantListData, comprehensiveMerchantListItems]);

  // GW事業者データを取得
  const { data: gwCompanyListData } = useGetGwCompaniesQuery(undefined);
  const uniqueData = gwCompanyListData
    ? Array.from(
        new Map(
          gwCompanyListData.map((item: any) => [item.gwCompanyCode, item])
        ).values()
      )
    : [];
  const gwCompanyListItems: DivisionDict[] = addBlank(
    getGwCompanyList(uniqueData)
  );

  useEffect(() => {
    setGwCompanyList(gwCompanyListItems);
  }, [gwCompanyListData, gwCompanyListItems]);

  const { data, refetch } = useGetIndividualCounselingProjectContentsQuery(
    props.params
  );
  const registeredData = data;

  useEffect(() => {
    refetch();
    setGatewayFormKbn(getFirstDivisionDict(contractServiceKbnItems));
    setGatewayFormKbn(getFirstDivisionDict(considerationStatusKbnItems));
    if (
      registeredData !== undefined &&
      individualConsultationBranchNo !== undefined
    ) {
      const gatewayFormKbnRegistered1 = getDivisionDict(
        contractServiceKbnItems,
        String(registeredData.contractServiceCode)
      );
      setMerchantName(registeredData.merchantName ?? "");
      setContractServiceCode(gatewayFormKbnRegistered1);
      setContractStyle(String(registeredData.contractStyle));
      selectContractRoute(contractStyle);
      const tmpConRou = comprehensiveMerchantListItems?.filter(
        (item) => item.value === registeredData.contractRoute
      )[0];
      if (tmpConRou) {
        setContractRoute(tmpConRou);
        setSelectedContractRoute(tmpConRou);
      }
      setConsiderationPolicyDetail(
        registeredData.considerationPolicyDetail ?? ""
      );
      setConsulteeName(registeredData.consulteeName ?? "");
      setReceptionDate(formatDateHyphen(registeredData.receivedDate));
      setConsulationReason(registeredData.consultationReason ?? "");
      setConsiderationStatus({
        value: registeredData.considerationStatus,
        label: registeredData.considerationStatus,
      });
      setConsiderationPolicy(registeredData.considerationPolicy ?? "");
      setNegotiatedCreditCardRate(
        registeredData.negotiatedCreditCardRate ?? ""
      );
      setConsulationResult(registeredData.counselingResult ?? "");
      setConsulationMemo(registeredData.considerationMemo ?? "");
      setCompanyName(registeredData.companyNameAfterApplication ?? "");
      setMerchantsName1(registeredData.merchantNameAfterApplication ?? "");
      setContractDetails(registeredData.contractDetailAfterApplication ?? "");
      setMessage(registeredData.message ?? "");
      setUpdatedAt(registeredData.updatedAt ?? "");
      setUpdatedBy(registeredData.updatedBy ?? "");
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [registeredData]);

  //各項目のバリデーションチェック
  //加盟店名チェック
  const merchantNameOnChange = (merchantName: string) => {
    if (isNull(merchantName)) {
      setMerchantNameErrorMsg(getMessage("KGRERR055").label);
      return false;
    } else if (!isLengthValid(merchantName, 100)) {
      setMerchantNameErrorMsg(getMessage("KGRERR058", 100).label);
      return false;
    }
    // ここまで来たら問題ないのでエラーを消す
    setMerchantNameErrorMsg("");
    return true;
  };

  //サービス名チェック
  const contractServiceCodeOnchange = (contractServiceCode: string) => {
    if (isNull(contractServiceCode)) {
      setContractServiceCodeErrorMsg(getMessage("KGRERR055").label);
      return false;
    }
    // ここまで来たら問題ないのでエラーを消す
    setContractServiceCodeErrorMsg("");
    return true;
  };

  //契約形態
  const contractStyleOnChange = (contractStyle: string) => {
    if (isNull(contractStyle)) {
      setContractStyleErrorMsg(getMessage("KGRERR055").label);
      return false;
    }
    // ここまで来たら問題ないのでエラーを消す
    setContractStyleErrorMsg("");
    return true;
  };

  //相談者情報チェック
  const consulteeNameOnchange = (consulteeName: string) => {
    if (isNull(consulteeName)) {
      setConsulteeNameErrorMsg(getMessage("KGRERR055").label);
      return false;
    } else if (!isLengthValid(consulteeName, 100)) {
      setConsulteeNameErrorMsg(getMessage("KGRERR058", 100).label);
      return false;
    }
    // ここまで来たら問題ないのでエラーを消す
    setConsulteeNameErrorMsg("");
    return true;
  };

  //受付日チェック
  const receptionDateOnchange = (receptionDate: string) => {
    if (isNull(receptionDate)) {
      setReceptionDateErrorMsg(getMessage("KGRERR055").label);
      return false;
    }
    // ここまで来たら問題ないのでエラーを消す
    setReceptionDateErrorMsg("");
    return true;
  };

  //相談理由チェック
  const consulationReasonOnchange = (consulationReason: string) => {
    if (isNull(consulationReason)) {
      setConsulationReasonErrorMsg(getMessage("KGRERR055").label);
      return false;
    } else if (!isLengthValid(consulationReason, 2000)) {
      setConsulationReasonErrorMsg(getMessage("KGRERR058", 2000).label);
      return false;
    }
    // ここまで来たら問題ないのでエラーを消す
    setConsulationReasonErrorMsg("");
    return true;
  };

  // 検討状況チェック
  const considerationStatusOnchange = (considerationStatus: string) => {
    if (isNull(considerationStatus)) {
      setConsiderationStatusErrorMsg(getMessage("KGRERR055").label);
      return false;
    }
    // ここまで来たら問題ないのでエラーを消す
    setConsiderationStatusErrorMsg("");
    return true;
  };

  //検討方針チェック
  const considerationPolicyOnchange = (considerationPolicy: string) => {
    if (isNull(considerationPolicy)) {
      setConsiderationPolicyErrorMsg(getMessage("KGRERR055").label);
      return false;
    } else if (!isLengthValid(considerationPolicy, 100)) {
      setConsiderationPolicyErrorMsg(getMessage("KGRERR058", 100).label);
      return false;
    }
    // ここまで来たら問題ないのでエラーを消す
    setConsiderationPolicyErrorMsg("");
    return true;
  };

  //検討方針詳細チェック
  const considerationPolicyDetailOnchange = (
    considerationPolicyDetail: string
  ) => {
    if (!isLengthValid(considerationPolicyDetail, 1000)) {
      setConsiderationPolicyDetailErrorMsg(getMessage("KGRERR058", 1000).label);
      return false;
    }
    // ここまで来たら問題ないのでエラーを消す
    setConsiderationPolicyDetailErrorMsg("");
    return true;
  };

  //クレカ料率チェック
  const negotiatedCreditCardRateOnchange = (
    negotiatedCreditCardRate: string
  ) => {
    if (!isHalfNumberDecimalValid(negotiatedCreditCardRate)) {
      setNegotiatedCreditCardRateErrorMsg(getMessage("KGRERR079", 3, 2).label);
      return false;
    }
    // ここまで来たら問題ないのでエラーを消す
    setNegotiatedCreditCardRateErrorMsg("");
    return true;
  };

  //相談結果チェック
  const consulationResultOnchange = (consulationResult: string) => {
    if (!isLengthValid(consulationResult, 2000)) {
      setConsulationResultErrorMsg(getMessage("KGRERR058", 2000).label);
      return false;
    }

    // ここまで来たら問題ないのでエラーを消す
    setConsulationResultErrorMsg("");
    return true;
  };

  //検討メモ
  const consulationMemoOnchange = (consulationMemo: string) => {
    if (!isLengthValid(consulationMemo, 2000)) {
      setConsulationMemoErrorMsg(getMessage("KGRERR058", 2000).label);
      return false;
    }

    // ここまで来たら問題ないのでエラーを消す
    setConsulationMemoErrorMsg("");
    return true;
  };

  //申し送り事項
  const messageOnchange = (message: string) => {
    if (!isLengthValid(message, 2000)) {
      setMessageErrorMsg(getMessage("KGRERR058", 2000).label);

      return false;
    }
    // ここまで来たら問題ないのでエラーを消す
    setMessageErrorMsg("");
    return true;
  };

  //登録更新ボタンクリック時のバリデーションチェック
  const validateInputs = () => {
    let flag = true;
    const checks = [
      merchantNameOnChange(merchantName),
      contractServiceCodeOnchange(contractServiceCode.value),
      contractStyleOnChange(contractStyle),
      consulteeNameOnchange(consulteeName),
      receptionDateOnchange(receptionDate),
      consulationReasonOnchange(consulationReason),
      considerationStatusOnchange(considerationStatus.value),
      considerationPolicyOnchange(considerationPolicy),
      considerationPolicyDetailOnchange(considerationPolicyDetail),
      negotiatedCreditCardRateOnchange(negotiatedCreditCardRate),
      consulationResultOnchange(consulationResult),
      consulationMemoOnchange(consulationMemo),
      messageOnchange(message),
    ];
    checks.forEach(function (value) {
      if (value === false) {
        flag = false;
      }
    });
    return flag;
  };

  //
  const consideration = [
    {
      label: "検討中",
      value: "検討中",
    },
  ];

  //契約形態選択時イベント
  const selectContractRoute = (value: string) => {
    if (value === "1") {
      setContractRouteItem(gwCompanyList);
    } else if (value === "2") {
      setContractRouteItem(comprehensiveMerchantList);
    } else {
      setContractRouteItem(consideration);
    }
  };

  // 登録ボタン押下イベント
  const onClickRegisterFormButton = () => {
    if (!validateInputs()) {
      return;
    }
    if (!isNull(negotiatedCreditCardRate)) {
      setNegotiatedCreditCardRate(negotiatedCreditCardRate + LABELS.PARAM);
    }
    const data: IndividualCounselingProjectContentsRegister = {
      individualConsultationNo: code,
      receivedDate: formatDate(receptionDate),
      consulteeName: consulteeName,
      consultationReason: consulationReason,
      considerationPolicy: considerationPolicy,
      considerationPolicyDetail: considerationPolicyDetail,
      merchantName: merchantName,
      contractServiceCode: Number(contractServiceCode.value),
      contractStyle: Number(contractStyle),
      contractRoute: contractRoute.value,
      considerationStatus: considerationStatus.label,
      considerationMemo: consulationMemo,
      negotiatedCreditCardRate: negotiatedCreditCardRate,
      counselingResult: consulationResult,
      message: message,
    };
    dispatch(
      showModal({
        title: COMMON_LABELS.TITLES.DL,
        content: COMMON_LABELS.CONTENTS.REGISTER_CONFIRM,
        positiveBtn: COMMON_LABELS.POSITIVE_BUTTON.OK,
        negativeBtn: COMMON_LABELS.NEGATIVE_BUTTON.CANCEL,
        positiveFn: () => {
          registerIndividualCounselingProjectContents(data).then(
            (result: any) => {
              if (!("error" in result)) {
                navigator("/individual-counseling-project/" + code);
              }
            }
          );
        },
      })
    );
  };

  //更新ボタン押下イベント
  const onClickUpdateFormButton = () => {
    if (!validateInputs()) {
      return;
    }
    dispatch(
      showModal({
        title: COMMON_LABELS.TITLES.DL,
        content: COMMON_LABELS.CONTENTS.UPDATE_CONFIRM,
        positiveBtn: COMMON_LABELS.POSITIVE_BUTTON.OK,
        negativeBtn: COMMON_LABELS.NEGATIVE_BUTTON.CANCEL,
        positiveFn: () => {
          if (!isNull(negotiatedCreditCardRate)) {
            setNegotiatedCreditCardRate(
              negotiatedCreditCardRate + LABELS.PARAM
            );
          }
          const updateData: IndividualCounselingProjectContentsUpdate = {
            receivedDate: formatDate(receptionDate),
            consulteeName: consulteeName,
            consultationReason: consulationReason,
            considerationPolicy: considerationPolicy,
            considerationPolicyDetail: considerationPolicyDetail,
            merchantName: merchantName,
            contractServiceCode: Number(contractServiceCode.value),
            contractStyle: Number(contractStyle),
            contractRoute: contractRoute.value,
            considerationStatus: considerationStatus.label,
            considerationMemo: consulationMemo,
            negotiatedCreditCardRate: negotiatedCreditCardRate,
            counselingResult: consulationResult,
            message: message,
          };
          const codeData: IndividualCounselingProjectContentsItem = {
            individualConsultationNo: Number(code),
            individualConsultationBranchNo: Number(
              individualConsultationBranchNo
            ),
          };
          const data: IndividualCounselingProjectContentsdata = {
            code: codeData,
            data: updateData,
          };
          updateIndividualCounselingProjectContents(data).then(
            (result: any) => {
              if (!("error" in result)) {
                navigator("/individual-counseling-project/" + code);
              }
            }
          );
        },
      })
    );
  };

  //戻るボタン
  const returnToProject = () => {
    if (!isFormEntered) {
      navigator("/individual-counseling-project/" + code);
    } else {
      dispatch(
        showModal({
          title: COMMON_LABELS.TITLES.DL,
          content: COMMON_LABELS.CONTENTS.PAGE_MOVE_CONFIRM,
          positiveBtn: COMMON_LABELS.POSITIVE_BUTTON.OK,
          negativeBtn: COMMON_LABELS.NEGATIVE_BUTTON.CANCEL,
          positiveFn: () => {
            navigator("/individual-counseling-project/" + code);
          },
        })
      );
    }
  };

  return (
    <SpaceBetween direction="vertical" size="l">
      <form onSubmit={(e) => e.preventDefault()}>
        <Form>
          <SpaceBetween direction="vertical" size="m">
            <Container
              header={
                <ColumnLayout columns={2}>
                  <Header variant="h2">{LABELS.CONSULTATION_CONTENT}</Header>
                  {!isRegister && (
                    <Box float="right">
                      <Badge color="green">
                        {LABELS.LAST_UPDATER}
                        {updatedBy}/{LABELS.LAST_UPDATING_TIME}
                        {formatYearDate(updatedAt)}
                      </Badge>
                    </Box>
                  )}
                </ColumnLayout>
              }
            >
              <SpaceBetween direction="vertical" size="l">
                <ColumnLayout columns={2}>
                  <FormField
                    label={
                      <SpaceBetween direction="horizontal" size="xs">
                        <Box variant="strong">{LABELS.MERCHANTS_NAME}</Box>
                        <Box variant="small" color="text-status-error">
                          {COMMON_LABELS.INPUT_ITEM_MESSAGE.REQUIRED}
                        </Box>
                      </SpaceBetween>
                    }
                    errorText={merchantNameErrorMsg}
                    constraintText="100文字以内"
                  >
                    <Input
                      name="merchantName"
                      value={merchantName}
                      onChange={(e) => {
                        setMerchantName(e.detail.value);
                        merchantNameOnChange(e.detail.value);
                        setIsFormEntered(true);
                      }}
                    />
                  </FormField>
                </ColumnLayout>
                <ColumnLayout columns={4}>
                  <FormField
                    label={
                      <SpaceBetween direction="horizontal" size="xs">
                        <Box variant="strong">{LABELS.SERVICE_NAME}</Box>
                        <Box variant="small" color="text-status-error">
                          {COMMON_LABELS.INPUT_ITEM_MESSAGE.REQUIRED}
                        </Box>
                      </SpaceBetween>
                    }
                    errorText={contractServiceCodeErrorMsg}
                  >
                    <Select
                      selectedOption={contractServiceCode}
                      options={serviceNameList}
                      filteringType="none"
                      onChange={(event: any) => {
                        setContractServiceCode(event.detail.selectedOption);
                        contractServiceCodeOnchange(
                          event.detail.selectedOption
                        );
                        setIsFormEntered(true);
                      }}
                    />
                  </FormField>
                </ColumnLayout>
                <FormField
                  label={
                    <SpaceBetween direction="horizontal" size="xs">
                      <Box variant="strong">{LABELS.CONTRACT_STATUS}</Box>
                      <Box variant="small" color="text-status-error">
                        {COMMON_LABELS.INPUT_ITEM_MESSAGE.REQUIRED}
                      </Box>
                    </SpaceBetween>
                  }
                  errorText={contractStyleErrorMsg}
                >
                  <Tiles
                    onChange={({ detail }) => {
                      setContractStyle(detail.value);
                      contractStyleOnChange(detail.value);
                      selectContractRoute(detail.value);
                      if (detail.value !== CONTRACT_STYLES[1].value) {
                        setContractRoute({ value: "", label: "" });
                      } else {
                        setContractRoute({
                          value: selectedContractRoute.value,
                          label: selectedContractRoute.label,
                        });
                      }
                      setIsFormEntered(true);
                    }}
                    value={contractStyle}
                    items={CONTRACT_STYLES}
                    columns={3}
                  ></Tiles>
                </FormField>
                <ColumnLayout columns={4}>
                  <FormField
                    label={
                      <SpaceBetween direction="horizontal" size="xs">
                        <Box variant="strong">{LABELS.CONTRACT_ROUTE}</Box>
                      </SpaceBetween>
                    }
                  >
                    <Select
                      disabled={contractStyle !== CONTRACT_STYLES[1].value}
                      selectedOption={contractRoute}
                      options={comprehensiveMerchantList}
                      filteringType="auto"
                      onChange={(event: any) => {
                        setContractRoute(event.detail.selectedOption);
                        setSelectedContractRoute(event.detail.selectedOption);
                        setIsFormEntered(true);
                      }}
                    />
                  </FormField>
                </ColumnLayout>
                <ColumnLayout columns={4}>
                  <FormField
                    label={
                      <SpaceBetween direction="horizontal" size="xs">
                        <Box variant="strong">{LABELS.CONSULTATION_INFO}</Box>
                        <Box variant="small" color="text-status-error">
                          {COMMON_LABELS.INPUT_ITEM_MESSAGE.REQUIRED}
                        </Box>
                      </SpaceBetween>
                    }
                    constraintText="100文字以内"
                    errorText={consulteeNameErrorMsg}
                  >
                    <Input
                      name="consulteeName"
                      value={consulteeName}
                      onChange={(e) => {
                        setConsulteeName(e.detail.value);
                        consulteeNameOnchange(e.detail.value);
                        setIsFormEntered(true);
                      }}
                    />
                  </FormField>
                  <FormField
                    label={
                      <SpaceBetween direction="horizontal" size="xs">
                        <Box variant="strong">{LABELS.RECEPTION_DATE}</Box>
                        <Box variant="small" color="text-status-error">
                          {COMMON_LABELS.INPUT_ITEM_MESSAGE.REQUIRED}
                        </Box>
                      </SpaceBetween>
                    }
                    errorText={receptionDateErrorMsg}
                  >
                    <DatePicker
                      onChange={({ detail }) => {
                        setReceptionDate(detail.value);
                        receptionDateOnchange(detail.value);
                        setIsFormEntered(true);
                      }}
                      value={receptionDate}
                      openCalendarAriaLabel={(selectedDate) =>
                        "Choose certificate expiry date" +
                        (selectedDate
                          ? `, selected date is ${selectedDate}`
                          : "")
                      }
                      nextMonthAriaLabel="Next month"
                      placeholder="YYYY/MM/DD"
                      previousMonthAriaLabel="Previous month"
                      todayAriaLabel="Today"
                    />
                  </FormField>
                </ColumnLayout>
                <FormField
                  stretch
                  label={
                    <SpaceBetween direction="horizontal" size="xs">
                      <Box variant="strong">{LABELS.CONSULATION_REASON}</Box>
                      <Box variant="small" color="text-status-error">
                        {COMMON_LABELS.INPUT_ITEM_MESSAGE.REQUIRED}
                      </Box>
                    </SpaceBetween>
                  }
                  constraintText="2000文字以内"
                  errorText={consulationReasonErrorMsg}
                >
                  <Textarea
                    value={consulationReason}
                    onChange={(e) => {
                      setConsulationReason(e.detail.value);
                      consulationReasonOnchange(e.detail.value);
                      setIsFormEntered(true);
                    }}
                  />
                </FormField>
              </SpaceBetween>
            </Container>
            <Container
              header={
                <Header variant="h2">{LABELS.EXAMINATION_POLICY_RESULT}</Header>
              }
            >
              <SpaceBetween direction="vertical" size="l">
                <ColumnLayout columns={4}>
                  <FormField
                    label={
                      <SpaceBetween direction="horizontal" size="xs">
                        <Box variant="strong">{LABELS.EXAMINATION_STATUS}</Box>
                        <Box variant="small" color="text-status-error">
                          {COMMON_LABELS.INPUT_ITEM_MESSAGE.REQUIRED}
                        </Box>
                      </SpaceBetween>
                    }
                    errorText={considerationStatusErrorMsg}
                  >
                    <Select
                      selectedOption={considerationStatus}
                      options={considerationStatusList}
                      onChange={(event: any) => {
                        setConsiderationStatus({
                          value: event.detail.selectedOption.value,
                          label: event.detail.selectedOption.label,
                        });
                        considerationStatusOnchange(
                          event.detail.selectedOption.label
                        );
                        setIsFormEntered(true);
                      }}
                    />
                  </FormField>
                </ColumnLayout>
                <ColumnLayout columns={2}>
                  <FormField
                    label={
                      <SpaceBetween direction="horizontal" size="xs">
                        <Box variant="strong">{LABELS.EXAMINATION_POLICY}</Box>
                        <Box variant="small" color="text-status-error">
                          {COMMON_LABELS.INPUT_ITEM_MESSAGE.REQUIRED}
                        </Box>
                      </SpaceBetween>
                    }
                    constraintText="100文字以内"
                    errorText={considerationPolicyErrorMsg}
                  >
                    <Input
                      name="considerationPolicy"
                      value={considerationPolicy}
                      onChange={(e) => {
                        setConsiderationPolicy(e.detail.value);
                        considerationPolicyOnchange(e.detail.value);
                        setIsFormEntered(true);
                      }}
                    />
                  </FormField>
                </ColumnLayout>
                <FormField
                  stretch
                  label={
                    <SpaceBetween direction="horizontal" size="xs">
                      <Box variant="strong">
                        {LABELS.EXAMINATION_POLICY_DETAIL}
                      </Box>
                    </SpaceBetween>
                  }
                  constraintText="1000文字以内"
                  errorText={considerationPolicyDetailErrorMsg}
                >
                  <Textarea
                    value={considerationPolicyDetail}
                    onChange={(e) => {
                      setConsiderationPolicyDetail(e.detail.value);
                      considerationPolicyDetailOnchange(e.detail.value);
                      setIsFormEntered(true);
                    }}
                  />
                </FormField>

                <Container
                  header={
                    <Header variant="h3">{LABELS.EXAMINATION_RESULT}</Header>
                  }
                >
                  <SpaceBetween direction="vertical" size="s">
                    <ColumnLayout columns={4}>
                      <FormField
                        label={LABELS.CREDIT_RATE}
                        constraintText="整数部分3桁,小数点以下2桁まで"
                        errorText={negotiatedCreditCardRateErrorMsg}
                      >
                        <Input
                          name="negotiatedCreditCardRate"
                          value={negotiatedCreditCardRate}
                          onChange={(e) => {
                            setNegotiatedCreditCardRate(e.detail.value);
                            negotiatedCreditCardRateOnchange(e.detail.value);
                            setIsFormEntered(true);
                          }}
                        />
                      </FormField>
                      <Box padding={{ top: "xxl" }} variant="awsui-key-label">
                        {LABELS.PARAM}
                      </Box>
                    </ColumnLayout>
                    <FormField
                      stretch
                      label={
                        <SpaceBetween direction="horizontal" size="xs">
                          <Box variant="strong">
                            {LABELS.CONSULATION_RESULT}
                          </Box>
                        </SpaceBetween>
                      }
                      constraintText="2000文字以内"
                      errorText={consulationResultErrorMsg}
                    >
                      <Textarea
                        value={consulationResult}
                        onChange={(e) => {
                          setConsulationResult(e.detail.value);
                          consulationResultOnchange(e.detail.value);
                          setIsFormEntered(true);
                        }}
                      />
                    </FormField>
                  </SpaceBetween>
                </Container>
                <FormField
                  stretch
                  label={LABELS.EXAMINATION_MEMO}
                  constraintText="2000文字以内"
                  errorText={consulationMemoErrorMsg}
                >
                  <Textarea
                    value={consulationMemo}
                    onChange={(e) => {
                      setConsulationMemo(e.detail.value);
                      consulationMemoOnchange(e.detail.value);
                      setIsFormEntered(true);
                    }}
                  />
                </FormField>
              </SpaceBetween>
            </Container>
            <Container
              header={
                <Header variant="h2">{LABELS.AFTER_MERCHANTS_INFO}</Header>
              }
            >
              <SpaceBetween direction="vertical" size="l">
                <ColumnLayout columns={5}>
                  <TextContent>
                    <h5>{LABELS.COMPANY_NAME}</h5>
                  </TextContent>
                  <TextContent>
                    <p>{companyName}</p>
                  </TextContent>
                </ColumnLayout>
                <ColumnLayout columns={5}>
                  <TextContent>
                    <h5>{LABELS.MERCHANTS_NAME}</h5>
                  </TextContent>
                  <TextContent>
                    <Link to="#">{merchantsName1}</Link>
                  </TextContent>
                </ColumnLayout>
                <ColumnLayout columns={5}>
                  <TextContent>
                    <h5>{LABELS.CONTRACT_DETAILS}</h5>
                  </TextContent>
                  <TextContent>
                    <p>{contractDetails}</p>
                  </TextContent>
                </ColumnLayout>
              </SpaceBetween>
            </Container>
            <Container
              header={
                <Header variant="h2">
                  {LABELS.APPLICATION_PROCEDURE_MATTER}
                </Header>
              }
            >
              <SpaceBetween direction="vertical" size="l">
                <FormField
                  stretch
                  label={LABELS.PROCEDURE_MATTER}
                  constraintText="2000文字以内"
                  errorText={messageErrorMsg}
                >
                  <Textarea
                    value={message}
                    onChange={(e) => {
                      setMessage(e.detail.value);
                      messageOnchange(e.detail.value);
                      setIsFormEntered(true);
                    }}
                  />
                </FormField>
              </SpaceBetween>
            </Container>
            <ColumnLayout columns={2}>
              <Box float="left">
                <Button variant="link" onClick={returnToProject}>
                  {COMMON_LABELS.BTNS.BACK}
                </Button>
              </Box>
              {isRegister && (
                <Box float="right">
                  <Button variant="primary" onClick={onClickRegisterFormButton}>
                    {COMMON_LABELS.BTNS.REGISTER}
                  </Button>
                </Box>
              )}
              {!isRegister && (
                <Box float="right">
                  <Button variant="primary" onClick={onClickUpdateFormButton}>
                    {COMMON_LABELS.BTNS.UPDATE}
                  </Button>
                </Box>
              )}
            </ColumnLayout>
          </SpaceBetween>
        </Form>
      </form>
    </SpaceBetween>
  );
};
